import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import { connect } from 'react-redux';

import RouteLink from '../../../../shared/components/routeLink';
import CreatorSignUp from '../creatorSignUp';
import BrandSignUp from '../brandSignUp';
import AccountType from '../../components/accountType';
import { history } from '../../../../store/store';
import { useQuery } from '../../../../shared/helpers/route.helper';
import { IState } from '../../../../shared/utilities/interfaces';
import AccountApproval from '../accountApproval';
import { Creator, Brand } from '../../../../shared/components/icons';

type UserType = 'CREATOR' | 'BRAND' | '';
const UserTypes = ['CREATOR', 'BRAND'];

interface ICreateAccount {
  accountStatus: string;
}

function CreateAccount(createAccountProps: ICreateAccount) {
  const [userType, setUserType] = useState<UserType>('');
  const [isSelected, setIsSelected] = useState(false);
  const query = useQuery();
  const { accountStatus } = createAccountProps;

  useEffect(() => {
    const value = query.get('account-type');
    if (UserTypes.includes(value)) {
      setUserType(value as UserType);
      setIsSelected(true);
    } else {
      setUserType('');
      setIsSelected(false);
    }
  }, [query.get('account-type')]);

  const getForm = () => {
    if (userType === 'CREATOR') {
      return (
        <CreatorSignUp />
      );
    } else if (userType === 'BRAND') {
      return (
        <BrandSignUp />
      );
    }
    return (
      <></>
    );
  };

  const selectAccountType = (type: UserType) => {
    setUserType(type);
    setIsSelected(true);
    history.push(`?account-type=${type}`);
  };

  if(accountStatus === 'PENDING')  {
    return (<AccountApproval />);
  } else if (accountStatus === 'REJECTED') {
    return (<AccountApproval rejected />);
  } else if(accountStatus === 'DEACTIVATED') {
    return (<AccountApproval inactive />);
  }
  else {
    return (<div>
      <Typography variant='h4' fontWeight="bold">
        Create an Account
      </Typography>
      <Typography
        variant='subtitle1'
        display='inline-block'
        sx={{
          fontSize: '14px',
          color: 'claraPalette.gray1',
          mt: '5px'
        }}
      >
        Already have an account?&nbsp;
      </Typography>
      <RouteLink
        to='/auth'
      >
        Sign In
      </RouteLink>
      <Box sx={{ mt: '2rem', display: 'flex', alignItems: 'center' }}>
        {(!isSelected || userType === 'CREATOR') && (
          <>
            <AccountType
              onClick={() => selectAccountType('CREATOR')}
              text="I'm a Creator"
              imgSrc={
                <Creator
                  iconColor={userType === 'CREATOR' ? 'black' : 'white'}
                  width={userType === 'CREATOR' ? '38' : '64'}
                  height={userType === 'CREATOR' ? '38' : '64'}
                />
              }
              className={`${userType === 'CREATOR' && 'selected'}`}
            />
            {isSelected && (
              <Typography
                color='black'
                className='type-text'
                sx={{
                  display: 'inline-block',
                  color: 'claraPalette.gray1'
                }}
              >
                Creator
              </Typography>
            )}
          </>)
        }
        {(!isSelected || userType === 'BRAND') && (
          <>
            <AccountType
              onClick={() => selectAccountType('BRAND')}
              text="I'm a Brand"
              imgSrc={
                <Brand
                  iconColor={userType === 'BRAND' ? 'black' : 'white'}
                  width={userType === 'BRAND' ? '38' : '64'}
                  height={userType === 'BRAND' ? '38' : '64'}
                />
              }
              className={`${userType === 'BRAND' && 'selected'}`}
            />
            {isSelected && (
              <Typography
                className='type-text'
                sx={{ display: 'inline-block', color: 'claraPalette.gray1' }}
              >
                Brand
              </Typography>
            )}
          </>)
        }
      </Box>
      {getForm()}
    </div>);
  }
}

export default connect((state: IState) => ({
  accountStatus: state.auth.status
}))(CreateAccount);
